export default "__VITE_ASSET__4e7958f3__"